import imageResolver, { ResolvedImage } from "./imageResolver";
import richTextResolver, { ResolvedRichText } from "./richTextResolver";
import { StaticCard } from "services/cms/models/staticCard";
import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import { Image } from "services/cms/models";
import { ResolvedMegaMenuCtaButton, transformCtaButton } from "./headerMegaMenuCTAResolver";

export type ResolvedStaticCard = {
    codename: string;
    image?: ResolvedImage;
    imageType: "small" | "large";
    heading?: string;
    headingLocation?: "above_image" | "below_image";
    copy?: ResolvedRichText;
    cta?: ResolvedMegaMenuCtaButton;
    type: ContentTypeCodenames.StaticCard;
    isInComponentWrapper: boolean;
    parentHasHeading: boolean;
};

const staticCardResolver = (
    data: StaticCard,
    isInComponentWrapper: boolean,
    parentHasHeading: boolean
): ResolvedStaticCard => {
    const linkedImage = data?.elements?.image?.linkedItems[0] as Image;
    const linkedCta = data.elements.cta.linkedItems[0];

    return {
        codename: data.system.codename,
        image: linkedImage ? imageResolver(linkedImage) : undefined,
        imageType: data.elements.imageType?.value?.[0]?.codename === "large" ? "large" : "small",
        heading: data.elements.heading?.value,
        headingLocation:
            data.elements.headingLocation?.value?.[0]?.codename === "above_image"
                ? "above_image"
                : "below_image",
        copy: richTextResolver({ html: data.elements.copy?.value }),
        cta: linkedCta && transformCtaButton(linkedCta),
        type: ContentTypeCodenames.StaticCard,
        isInComponentWrapper,
        parentHasHeading,
    };
};

export default staticCardResolver;
